import {
  DELETE_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME,
  GET_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME,
  POST_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME,
  PUT_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME,
} from "../constants/actionTypes";

const defaultState = {}
let data=[]
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME:
        return {...state,...action.payload};
      case POST_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME:
        return {...action.payload};
      case PUT_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME:
        return {...state,...action.payload};
      case DELETE_INVESTMENT_HOLDING_OTHER_NON_TAXABLE_INCOME:
        data = [...state.otherIncomeArr];
        const newData = data?.filter(
          (income) => income.id!=action.payload,
        );
        return {...state,otherIncomeArr: [...newData]};
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
